import React, { useEffect, useRef, useState } from 'react'
import ChangePasswordIcon from '../../../../assets/images/lystfacelogos/AccountSetting/ChangePassword.svg';
import { Form, FormFeedback, Input, Label, Modal } from 'reactstrap';
import * as Yup from "yup"
import { useFormik } from "formik";
import form_messages from '../../../../constants/form_messages';
import form_input_patterns from '../../../../constants/form_input_patterns';
import PasswordToolTip from "../../../../components/Common/PasswordToolTip";
import SmallLoader from "../../../../components/Common/SmallLoader"
import showpasswordlogo from "../../../../assets/images/lystfacelogos/showpassword.svg"
import hidpasswordlogo from "../../../../assets/images/lystfacelogos/hidepassword.svg"
import { useDispatch, useSelector } from 'react-redux';
import { changePassword, changePasswordReset } from '../../../../store/menu/application/actions';
import { createSelector } from 'reselect';
import { CustomToast } from '../../../../components/Lystface/Common/CustomToast';

export default function ChangePassword() {
    const dispatch = useDispatch();

    const [openModal, setOpenModal] = useState(false);
    const [isShowPassword, setIsShowPassword] = useState({
        currentPassword: false,
        password: false,
        confirmPassword: false,
    })


    const selectAccountSetting = state => state.Application;
    const responseAccountSetting = createSelector(selectAccountSetting, account => ({
        responseMessage: account.changePassword?.responseMessage,
        responseStatus: account.changePassword?.responseStatus,
        loading: account.changePassword?.loading,
    }))
    const {
        responseStatus,
        responseMessage,
        loading
    } = useSelector(responseAccountSetting);

    const currentPasswordRef = useRef(null);
    const passwordRef = useRef(null);
    const confirmPasswordRef = useRef(null);

    useEffect(() => {
        if (currentPasswordRef.current) {
            currentPasswordRef.current.setAttribute('autocomplete', 'new-password');
        }
        if (passwordRef.current) {
            passwordRef.current.setAttribute('autocomplete', 'new-password');
        }
        if (confirmPasswordRef.current) {
            confirmPasswordRef.current.setAttribute('autocomplete', 'new-password');
        }
    }, []);

    const validationType = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: {
            currentPassword: '',
            password: "",
            confirmPassword: "",
        },
        validationSchema: Yup.object().shape({
            currentPassword: Yup.string()
                .matches(
                    form_input_patterns.ONLYENGLISHTEXT,
                    form_messages.Common.INVALID("Current password")
                )
                .required(form_messages.Signup.password.CurrentPassword),
            password: Yup.string()
                .matches(
                    form_input_patterns.ONLYENGLISHTEXT,
                    form_messages.Common.INVALID("New password")
                )
                .matches(
                    form_input_patterns.PASSWORD,
                    form_messages.Signup.password.MATCH
                )
                .required(form_messages.Signup.password.NewPassword),

            confirmPassword: Yup.string()
                .matches(
                    form_input_patterns.ONLYENGLISHTEXT,
                    form_messages.Common.INVALID("Confirm password")
                )
                .when("password", (password, schema) => {
                    return password && password.length > 0
                        ? schema
                            .oneOf([Yup.ref("password")], form_messages.Signup.password.SAME)
                            .required(form_messages.Signup.password.ConfirmRequired)
                        : schema.notRequired()

                }),
        }),
        onSubmit: async values => {
            const UpdatePwd = {
                oldpwd: values.currentPassword.trim(),
                newpwd: values.password.trim(),
            }
            dispatch(changePassword(UpdatePwd))
            // cancelForm();
        },
    })

    const onSubmitForm = () => {
        validationType.handleSubmit()
        return false
    }

    const handleSetPassword = (e) => {
        setIsShowPassword(prev => {
            return {
                ...prev,
                [e.target.name]: !isShowPassword?.[e.target.name],
            }
        })
    }

    const cancelForm = (value) => {
        setOpenModal(false)
        validationType.resetForm()
        setIsShowPassword({
            currentPassword: false,
            password: false,
            confirmPassword: false,
        })
    }

    useEffect(() => {
        if (responseStatus === 'Success') {
            cancelForm();
        }
        if (responseStatus && responseMessage) {
            CustomToast({
                message: responseStatus === 'Error' ? responseMessage : responseMessage,
                status: responseStatus === 'Error' ? 'failure' : 'success',
                closeToast: () => {
                    console.log('Toast closed');
                },
            })
            dispatch(changePasswordReset())
        }
    }, [responseStatus])

    return (
        <>
            <Modal
                className="model-card mx-auto"
                isOpen={openModal}
                centered={true}
            >
                <div className="model-header-custom">
                    <span className="title">Change password</span>
                    <button
                        type="button"
                        onClick={() => cancelForm()}
                        className="close button"
                        data-dismiss="modal"
                        aria-label="Close"
                    ></button>
                </div>

                <div className='body-modal'>
                    <div className="auth-form-container-box">

                        <div className="form-fields-container">

                            <div className={`form-password-container ${validationType.touched.confirmPassword && validationType.errors.confirmPassword
                                ? ``
                                : `conditional-margin`
                                }`}>
                                <Label className="form-input-title">
                                    Current password<span className="text-danger"> *</span>
                                </Label>

                                <Input
                                    name="currentPassword"
                                    type={isShowPassword.currentPassword ? `text` : "password"}
                                    className={`form-input password-input ${validationType.touched.currentPassword && validationType.errors.currentPassword
                                        ? `border-danger`
                                        : ``
                                        }`}
                                    onChange={(e) => {
                                        let inputValue = e.target.value.replace(/\s/g, ''); // Remove spaces
                                        validationType.setFieldValue('currentPassword', inputValue); // Directly set the field value
                                    }}
                                    onBlur={validationType.handleBlur}
                                    value={validationType.values.currentPassword || ""}
                                    autoComplete="new-password"
                                    ref={currentPasswordRef}
                                />
                                <span onClick={(e) => handleSetPassword(e)} className="password-icon">
                                    <img
                                        name="currentPassword"
                                        src={
                                            isShowPassword.currentPassword
                                                ? showpasswordlogo
                                                : hidpasswordlogo
                                        }
                                    />
                                </span>

                            </div>
                            <div className="conditional-margin">

                                {validationType.touched.currentPassword &&
                                    validationType.errors.currentPassword ? (
                                    <FormFeedback type="invalid" className="d-block">
                                        {validationType.errors.currentPassword}
                                    </FormFeedback>
                                ) : null}
                            </div>


                            <div className={`form-password-container ${validationType.touched.password && validationType.errors.password
                                ? ``
                                : `conditional-margin`
                                }`}>
                                <div className="d-flex align-items-end">
                                    <Label className="me-1 form-input-title">
                                        New password
                                        <span className="text-danger"> *</span>
                                    </Label>
                                    <PasswordToolTip id="passwordTooltip" />
                                </div>


                                <Input
                                    name="password"
                                    className={` form-input password-input ${validationType.touched.password &&
                                        validationType.errors.password
                                        ? `border-danger`
                                        : ``
                                        }`}
                                    type={isShowPassword.password ? `text` : "password"}
                                    onChange={(e) => {
                                        let inputValue = e.target.value.replace(/\s/g, ''); // Remove spaces
                                        validationType.setFieldValue('password', inputValue); // Directly set the field value
                                    }}
                                    onBlur={validationType.handleBlur}
                                    value={validationType.values.password || ""}
                                    autoComplete="new-password"
                                    ref={passwordRef}
                                />
                                <span onClick={(e) => handleSetPassword(e)} className="password-icon">
                                    <img
                                        name="password"
                                        src={
                                            isShowPassword.password
                                                ? showpasswordlogo
                                                : hidpasswordlogo
                                        }
                                    />
                                </span>

                            </div>
                            <div className="conditional-margin">

                                {validationType.touched.password &&
                                    validationType.errors.password ? (
                                    <FormFeedback type="invalid" className="d-block">
                                        {validationType.errors.password}
                                    </FormFeedback>
                                ) : null}
                            </div>
                            <div className={`form-password-container ${validationType.touched.confirmPassword && validationType.errors.confirmPassword
                                ? ``
                                : `conditional-margin`
                                }`}>
                                <Label className="form-input-title">
                                    Confirm password<span className="text-danger"> *</span>
                                </Label>

                                <Input
                                    name="confirmPassword"
                                    type={isShowPassword.confirmPassword ? `text` : "password"}
                                    className={`form-input password-input ${validationType.touched.confirmPassword && validationType.errors.confirmPassword
                                        ? `border-danger`
                                        : ``
                                        }`}
                                    onChange={(e) => {
                                        let inputValue = e.target.value.replace(/\s/g, ''); // Remove spaces
                                        validationType.setFieldValue('confirmPassword', inputValue); // Directly set the field value
                                    }}
                                    onBlur={validationType.handleBlur}
                                    value={validationType.values.confirmPassword || ""}
                                    autoComplete="new-password"
                                    ref={confirmPasswordRef}
                                />
                                <span onClick={(e) => handleSetPassword(e)} className="password-icon">
                                    <img
                                        name="confirmPassword"
                                        src={
                                            isShowPassword.confirmPassword
                                                ? showpasswordlogo
                                                : hidpasswordlogo
                                        }
                                    />
                                </span>

                            </div>
                            <div className="conditional-margin">

                                {validationType.touched.confirmPassword &&
                                    validationType.errors.confirmPassword ? (
                                    <FormFeedback type="invalid" className="d-block">
                                        {validationType.errors.confirmPassword}
                                    </FormFeedback>
                                ) : null}
                            </div>



                        </div>


                    </div>
                </div>

                <div className='footer-modal'>
                    <div className='cancelButton' onClick={() => cancelForm()}>Cancel</div>
                    <div >
                        <button disabled={loading} className={`${loading ? 'submitButton button-disabled' : 'submitButton'}`} onClick={() => onSubmitForm()} >                        Submit
                            {loading &&
                                <div className="spinner-container spinner-border">
                                </div>}
                        </button>
                    </div>
                </div>

            </Modal>
            <div className='singleLineCard'>
                <div className='flexData'>
                    <img src={ChangePasswordIcon} alt="lystface maroof" />
                    <div className='heading'>Change password</div>
                </div>

                <div className="manage-button">
                    <button
                        onClick={() => {
                            setOpenModal(true)
                        }}
                    >Change</button>
                </div>
            </div>
        </>
    )
}
